import { useIsDesktop } from '@cian/valuation-utils-component';
import { ArticleHeading1, ArticleHeading3, ArticleParagraph1, LinkButton } from '@cian/ui-kit';
import { forwardRef } from 'react';

import { content } from './content';
import { SvgRender } from '../../packages/SvgRender';
import { Wrapper } from '../Wrapper';
import { applicationFormUrl } from '../../constants/urls';
import { NBSP } from '../../constants/symbols';

import * as styles from './styles.css';

export interface IHelpSearchRealtorProps {
  onClickGoToApplicationForm(): void;
}

export const HelpSearchRealtor = forwardRef<HTMLDivElement, IHelpSearchRealtorProps>(
  ({ onClickGoToApplicationForm }, ref) => {
    const isDesktop = useIsDesktop();

    return (
      <div ref={ref} className={styles['container']}>
        <Wrapper>
          <div className={styles['title']}>
            <ArticleHeading1>
              {isDesktop ? `Найти хорошего риелтора непросто. Мы${NBSP}поможем!` : 'Почему с нами стоит работать'}
            </ArticleHeading1>
          </div>
          <div className={styles['content']}>
            {content.map((item, index) => {
              return (
                <div key={index} className={styles['content-item']}>
                  <div className={styles['icon']}>
                    <SvgRender src={item.iconSrc} width={90} height={90} />
                  </div>
                  <div className={styles['content-title']}>
                    <ArticleHeading3>{item.title}</ArticleHeading3>
                  </div>
                  <ArticleParagraph1>{item.text}</ArticleParagraph1>
                </div>
              );
            })}
          </div>
          <div className={styles['submit']}>
            <LinkButton
              data-testid="HelpSearchRealtor_link"
              href={applicationFormUrl}
              onClick={onClickGoToApplicationForm}
              theme="fill_primary"
              size="L"
              fullWidth={!isDesktop}
            >
              Подобрать риелтора
            </LinkButton>
          </div>
        </Wrapper>
      </div>
    );
  },
);

HelpSearchRealtor.displayName = 'HelpSearchRealtor';
